// filepath: src/components/user-info-header/index.tsx
import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import {
  Wrapper,
  InfoBlock,
  TextContainer,
  PrimaryText,
  SecondaryText,
  LogoutButton,
} from "./styles";
import theme from "../../../../styles/theme";
import useUserStore from "../../../../store/user";

interface UserInfoHeaderProps {
  balance: number;
  userName: string;
  userRole: string;
}

export const UserInfoHeader: React.FC<UserInfoHeaderProps> = ({ userRole }) => {
  const { user, clearUser } = useUserStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearUser();
    navigate("/login");
  };
  const parseUserType = (userType: string) => {
    switch (userType) {
      case "CUSTOMER":
        return "Cliente";
      case "PORTFOLIO_MANAGER":
        return "Supervisor de Contas";
      case "GMAIL_MANAGER":
        return "Conta Google (importador)";
      case "ADMIN":
        return "Admin";
      case "STAFF":
        return "Vendedor";
      default:
        return "";
    }
  };
  return (
    <Wrapper>
      <InfoBlock>
        <AccountCircleIcon
          sx={{ fontSize: 48, color: theme.colors.blue.primary }}
        />
        <TextContainer>
          <PrimaryText style={{ fontWeight: 700 }}>{user?.name}</PrimaryText>
          <SecondaryText>
            {parseUserType(user?.userType ?? userRole)}
          </SecondaryText>
        </TextContainer>
      </InfoBlock>
      <LogoutButton onClick={handleLogout}>
        <LogoutIcon />
      </LogoutButton>
    </Wrapper>
  );
};
